import React from 'react';
import { storeInfo } from '../data/mockData';
import { MapPin, Clock, Phone, Navigation } from 'lucide-react';

const VisitSection = () => (
  <section id="visit" className="py-20 bg-[#0f0f0f]">
    <div className="max-w-7xl mx-auto px-6">
      <h2 className="text-4xl md:text-5xl font-bold text-center mb-12">
        <span className="text-white">Visit Us at </span>
        <span className="text-[#c8ff00]">Westgate</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
        {/* Address */}
        <div className="bg-[#111] border border-[#222] rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <MapPin size={22} className="text-[#c8ff00]" />
            <h3 className="text-white font-bold text-lg">Address</h3>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed">
            {storeInfo.address.line1}<br />
            {storeInfo.address.line2}<br />
            {storeInfo.address.line3}<br />
            {storeInfo.address.line4}
          </p>
        </div>

        {/* Hours */}
        <div className="bg-[#111] border border-[#222] rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <Clock size={22} className="text-[#c8ff00]" />
            <h3 className="text-white font-bold text-lg">Opening Hours</h3>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed">
            {storeInfo.hours.weekday}<br />
            {storeInfo.hours.sunday}
          </p>
        </div>

        {/* Contact */}
        <div className="bg-[#111] border border-[#222] rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <Phone size={22} className="text-[#c8ff00]" />
            <h3 className="text-white font-bold text-lg">Contact</h3>
          </div>
          <div className="space-y-2">
            <p className="text-gray-400 text-sm">
              Phone: <a href={storeInfo.contact.phoneLink} className="text-[#c8ff00] hover:underline">{storeInfo.contact.phone}</a>
            </p>
            <p className="text-gray-400 text-sm">
              WhatsApp: <a href={storeInfo.contact.whatsapp} target="_blank" rel="noopener noreferrer" className="text-[#c8ff00] hover:underline">Chat with us</a>
            </p>
            <p className="text-gray-400 text-sm">
              Email: <a href={`mailto:${storeInfo.contact.email}`} className="text-[#c8ff00] hover:underline">{storeInfo.contact.email}</a>
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-4">
        <a
          href={storeInfo.contact.directions}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#c8ff00] text-black font-semibold px-6 py-3 rounded-xl hover:bg-[#b8ef00] transition-colors duration-200"
        >
          <Navigation size={18} />
          Get Directions
        </a>
        <a
          href={storeInfo.contact.phoneLink}
          className="inline-flex items-center gap-2 border border-[#555] text-white px-6 py-3 rounded-xl hover:border-[#c8ff00] hover:text-[#c8ff00] transition-colors duration-200"
        >
          <Phone size={18} />
          Call Now
        </a>
      </div>
    </div>
  </section>
);

export default VisitSection;
